// extracted by mini-css-extract-plugin
export default {"numberFieldWithFlexibility":"numberFieldWithFlexibility__MDg1O","checkbox":"checkbox__MGE5O"};